import React, {useEffect, useState} from "react"
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome"
import {solid} from "@fortawesome/fontawesome-svg-core/import.macro"

import AuthService from "../../services/auth.service"
import "./miNombre.css"

/*
	Cómo mostrar mi nombre en WAPP (Esteban, 2026-10-29): en el menú de la foto, cada quien elige cuál de sus nombres y
	cuál de sus apellidos se enseñan (o el nombre completo). Las opciones las arma el back con sus nombres reales
	(App\Support\NombrePersonal); al elegir una se guarda y se ve igual en WappTeam, WappChat, CRM, avisos y horarios.
	El <select> va invisible encima de la caja: en iPhone uno con flecha propia sale con dos flechas.
*/

type Opcion = {clave : string, texto : string}

type Props =
{
	nombre    : string
	disabled? : boolean
	onCambio  : (nombre : string) => void
}

const MiNombre = ({nombre, disabled, onCambio} : Props) =>
{
	const [opciones, setOpciones]   = useState<Opcion[] | null>(null)
	const [eleccion, setEleccion]   = useState<string>("0-0")
	const [guardando, setGuardando] = useState<boolean>(false)
	const [aviso, setAviso]         = useState<string | null>(null)

	useEffect
	(
		() =>
		{
			let vivo = true
			AuthService.miNombre().then
			(
				(r : any) =>
				{
					if(!vivo)
					{
						return
					}
					setOpciones(r.data.opciones || [])
					setEleccion(r.data.eleccion || "0-0")
					if(r.data.actual && r.data.actual !== nombre)
					{
						onCambio(r.data.actual)
					}
				}
			).catch(() => vivo && setOpciones([]))
			return () => { vivo = false }
		},
		[]
	)

	const elegir = async (clave : string) =>
	{
		const antes = eleccion
		setEleccion(clave)
		setGuardando(true)
		setAviso(null)
		try
		{
			const r : any = await AuthService.guardarMiNombre(clave)
			setEleccion(r.data.eleccion || "0-0")
			setOpciones(r.data.opciones || opciones)
			onCambio(r.data.actual)
		}
		catch(err : any)
		{
			setEleccion(antes)
			setAviso(err?.response?.data?.message || "No se pudo guardar. Intenta de nuevo.")
		}
		finally
		{
			setGuardando(false)
		}
	}

	const elegida = opciones?.find((o) => o.clave === eleccion)

	return <div className="miNombre">
		<b className="miNombreActual">{nombre}</b>
		{
			!opciones || opciones.length < 2 ? null : <div className="miNombreCampo">
				<span className="miNombreEtiqueta" id="miNombreEtiqueta">Cómo Mostrar Nombre</span>
				<span className={"miNombreSelect" + (guardando ? " guardando" : "")}>
					<span className="miNombreValor">{elegida ? elegida.texto : nombre}</span>
					<FontAwesomeIcon icon={guardando ? solid("spinner") : solid("chevron-down")} spin={guardando} />
					<select value={eleccion} disabled={disabled || guardando} aria-labelledby="miNombreEtiqueta"
						onChange={(e) => elegir(e.target.value)}
					>
						{opciones.map((o) => <option key={o.clave} value={o.clave}>{o.clave === "completo" ? o.texto + " (completo)" : o.texto}</option>)}
					</select>
				</span>
			</div>
		}
		{aviso ? <div className="miNombreAviso" role="status">{aviso}</div> : null}
	</div>
}

export default MiNombre
